module.exports = __webpack_public_path__ + "img/asset_mSOL.64c695c4.svg";